import { Card } from "react-bootstrap";
import ConfirmEventPopup from "../../_metronic/layout/components/common/ConfirmEventPopup";
import AddEditAnnouncementModal from "./components/AddEditAnnouncementModal";
import AnnouncementsTable from "./components/AnnouncementsTable";
import ViewAnnouncementModal from "./components/ViewAnnouncementModal";
import { useAdminAnnouncements } from "./hooks/useAdminAnnouncements";

const AdminAnnouncements: React.FC = () => {
  const {
    tableOptions,
    tableData,
    columns,
    selectedRow,
    showAddEditModal,
    showDeleteConfirmModal,
    showViewModal,
    viewData,
    loading,
    isDeletingAnnouncement,
    handlePagination,
    handleLastPage,
    handleFirstPage,
    handleModalClose,
    handleCloseDelete,
    handleViewClose,
    handleAddClick,
    handleSaveAnnouncement,
    handleDeleteAnnouncement,
  } = useAdminAnnouncements();

  return (
    <Card className="p-6">
      <AnnouncementsTable
        columns={columns}
        tableOptions={tableOptions}
        tableData={tableData}
        loading={loading}
        handleAddClick={handleAddClick}
        handlePagination={handlePagination}
        handleLastPage={handleLastPage}
        handleFirstPage={handleFirstPage}
      />
      {showAddEditModal && (
        <AddEditAnnouncementModal
          show={showAddEditModal}
          handleClose={() => handleModalClose()}
          editData={selectedRow}
          onSave={handleSaveAnnouncement}
        />
      )}
      {showDeleteConfirmModal && (
        <ConfirmEventPopup
          showPopup={showDeleteConfirmModal}
          handleClose={handleCloseDelete}
          handleConfirmed={handleDeleteAnnouncement}
          loading={isDeletingAnnouncement}
          title={"Delete Announcement"}
          message={"Are you sure, want to delete this announcement?"}
        />
      )}
      {showViewModal && viewData && (
        <ViewAnnouncementModal
          show={showViewModal}
          handleClose={handleViewClose}
          data={viewData}
        />
      )}
    </Card>
  );
};

export default AdminAnnouncements;
